/* @flow */
/** @jsx h */
import { Component, h } from 'preact';
import cssStyle from './index.css';

interface CtaIconProps {
  iconStyle: h.JSX.CSSProperties;
}

export default class CtaIcon extends Component<CtaIconProps> {
  render() {
    const { iconStyle } = this.props;
    return (
      <div data-zone="cta" className={cssStyle.ctaIcon}>
        <svg width="6px" height="10px" viewBox="0 0 6 10" version="1.1">
          <defs>
            <polygon
              id="path-1"
              points="11 17.825 14.708502 14 11 10.175 12.1417004 9 17 14 12.1417004 19"
            ></polygon>
          </defs>
          <g stroke="none" stroke-width="1">
            <g transform="translate(-11.000000, -9.000000)">
              <mask id="mask-2">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use id="arrow" style={iconStyle} xlinkHref="#path-1"></use>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}
